import React from 'react';

import { Box, Typography } from '@mui/material';

import { IToastComponentProps } from './types';

import styles from './ToastComponent.module.scss';

export const ToastComponent: React.FC<IToastComponentProps> = ({ title, message }) => (
  <Box className={styles.toastComponent}>
    {title && <Typography variant="h6">{title}</Typography>}
    {message && <Typography variant="subtitle2">{message}</Typography>}
  </Box>
);
